import { Permission } from '@weave/schema-gen-ts/dist/shared/waccess/acls.pb';
import { MessagingInboxOrg } from '@wetags/messaging-inbox';
import { useOrgLocationTree } from '@frontend/org-location-picker';

/**
 * Hook that manages org-level template selector visibility
 * Determines if org-level location selector should be shown based on:
 * - Whether feature flag 'template-org-level-selector' is enabled
 * - Whether user has access to more than one location
 */
export const useOrgLevelTemplateSelector = () => {
  const { accessibleCount } = useOrgLocationTree({ permission: Permission.MANUAL_MESSAGE_TEMPLATES_MANAGE });
  const [isOrgLevelSelector] = MessagingInboxOrg.useWetag('template-org-level-selector');
  const showOrgLevelSelector = isOrgLevelSelector && accessibleCount > 1;

  return {
    showOrgLevelSelector,
  };
};
